var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopPotrateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8335 11.4562C13.0622 11.9987 11.974 11.9987 9.79763 11.9987H7.14291C4.96656 11.9987 3.87839 11.9987 3.10703 11.4562C2.82165 11.2554 2.57343 11.0061 2.37361 10.7194C1.8335 9.94456 1.8335 8.8515 1.8335 6.66536C1.8335 4.47921 1.8335 3.38614 2.37361 2.6113C2.57343 2.32464 2.82165 2.0753 3.10703 1.87458C3.87839 1.33203 4.96656 1.33203 7.14291 1.33203",
    stroke: "#808191",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12V14.6667",
    stroke: "#808191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 14.668H11.1668",
    stroke: "#808191",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 1.33203C13.7569 1.33203 14.3854 1.33203 14.776 1.72256C15.1665 2.11308 15.1665 2.74162 15.1665 3.9987V6.66536C15.1665 7.92243 15.1665 8.55096 14.776 8.9415C14.3854 9.33203 13.7569 9.33203 12.4998 9.33203H11.8332C10.5761 9.33203 9.94757 9.33203 9.55704 8.9415C9.1665 8.55096 9.1665 7.92243 9.1665 6.66536V3.9987C9.1665 2.74162 9.1665 2.11308 9.55704 1.72256C9.94757 1.33203 10.5761 1.33203 11.8332 1.33203H12.4998Z",
    stroke: "#808191",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 7.66797H12.1724",
    stroke: "#808191",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopPotrateIcon);
export default __webpack_public_path__ + "static/media/desktop-potrate-icon.0087d6eb95df6118816ae4b2f4c6787d.svg";
export { ForwardRef as ReactComponent };